/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  BLUE_CREEK,
  DARK_BLUE_CREEK,
  DARK_GREEN_CREEK,
  DARK_RED_CREEK,
  GREEN_CREEK,
  LIGHT_GREY,
  RED_CREEK,
  WHITE,
} from '../../styles/colors';
import { FADE_IN_KEYFRAMES } from '../../styles/animations';
import { SmallText, MediumText, DISABLED } from '../../styles/styles';


export const BIG_BUTTON_STYLE = css`
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  ${MediumText};
  animation: 1s ${FADE_IN_KEYFRAMES};
  cursor: pointer;

  &:disabled {
    ${DISABLED}
  }
`;

export const MEDIUM_BUTTON_STYLE = css`
  padding: 5px 20px;
  text-align: center;
  text-decoration: none;
  ${SmallText};
  animation: 1s ${FADE_IN_KEYFRAMES};
  cursor: pointer;

  &:disabled {
    ${DISABLED}
  }
`;

export const SMALL_BUTTON_STYLE = css`
  padding: 8px 15px;
  text-align: center;
  text-decoration: none;
  ${SmallText};
  animation: 1s ${FADE_IN_KEYFRAMES};
  cursor: pointer;

  &:disabled {
    ${DISABLED}
  }
`;

const bigButton = (
  backgroundColor: string,
  hoverBackgroundColor: string,
  textColor: string,
  hoverTextColor: string,
) => styled.button`
  background-color: ${backgroundColor}; 
  color: ${textColor};
  border: none;

  ${BIG_BUTTON_STYLE};

  &:hover {
    background-color: ${hoverBackgroundColor}; 
    color: ${hoverTextColor};
  }
`;

const mediumButton = (
  backgroundColor: string,
  hoverBackgroundColor: string,
  textColor: string,
  hoverTextColor: string,
) => styled('button')`
  background-color: ${backgroundColor}; 
  color: ${textColor};
  border: none;
  
  ${MEDIUM_BUTTON_STYLE};

  &:hover {
    background-color: ${hoverBackgroundColor}; 
    color: ${hoverTextColor};
  }
`;

const bigSecondaryButton = (
  backgroundColor: string,
  hoverBackgroundColor: string,
  textColor: string,
  hoverTextColor: string,
) => styled('button')`
  ${BIG_BUTTON_STYLE};
  
  background-color: ${backgroundColor}; 
  border: solid 1px ${textColor};
  padding: 14px 31px;
  color: ${textColor};
  
  &:hover {
    background-color: ${hoverBackgroundColor}; 
    color: ${hoverTextColor};
  }
`;

const smallButton = (
  backgroundColor: string,
  hoverBackgroundColor: string,
  textColor: string,
  hoverTextColor: string,
) => styled('button')`
  ${SMALL_BUTTON_STYLE};
  
  background-color: ${backgroundColor}; 
  border: solid 1px ${textColor};
  color: ${textColor};
  
  &:hover {
    background-color: ${hoverBackgroundColor}; 
    color: ${hoverTextColor};
  }
`;

export const BigPositive  = bigButton(GREEN_CREEK, DARK_GREEN_CREEK, WHITE, WHITE);
export const BigNeutral   = bigButton(BLUE_CREEK, DARK_BLUE_CREEK, WHITE, WHITE);
export const BigNegative  = bigButton(RED_CREEK, RED_CREEK, WHITE, WHITE);
export const BigSecondary = bigSecondaryButton(WHITE, LIGHT_GREY, BLUE_CREEK, DARK_BLUE_CREEK);
export const BigSecondaryRed = bigSecondaryButton(WHITE, LIGHT_GREY, RED_CREEK, DARK_RED_CREEK);

export const MediumNeutral = mediumButton(BLUE_CREEK, DARK_BLUE_CREEK, WHITE, WHITE);

export const SmallNeutral = smallButton(BLUE_CREEK, DARK_BLUE_CREEK, WHITE, WHITE);
export const SmallSecondary = smallButton(WHITE, LIGHT_GREY, BLUE_CREEK, DARK_BLUE_CREEK);
